/*
  Analytics consent.

  Google Analytics used to load in index.js before the app rendered, for
  every visitor, with nothing asked. That is the tracking the DPDP Act
  and the GDPR both expect a choice about — so the tag now waits for
  one, and a visitor who declines is never sent to Google at all.

  Only two states are stored, and only the visitor's own choice. There
  is no "essential cookies" toggle because the site sets none: the cart
  and the login session live in localStorage, which no consent banner
  can lawfully be required for.
*/

const KEY = 'cs_cookie_consent_v1';

export const GRANTED = 'granted';
export const DENIED = 'denied';

/** 'granted' | 'denied' | null when they haven't been asked yet. */
export const readConsent = () => {
  try {
    const value = localStorage.getItem(KEY);
    return value === GRANTED || value === DENIED ? value : null;
  } catch {
    // Private mode, or storage blocked. Treat as "not asked", which
    // means no tracking — the safe side to fail on.
    return null;
  }
};

export const saveConsent = (value) => {
  try {
    localStorage.setItem(KEY, value);
  } catch {
    /* nothing to do — the choice just won't survive this session */
  }

  // So a policy page open in another tab can update its own display.
  window.dispatchEvent(new CustomEvent('cs-consent', { detail: value }));
};

export const hasConsented = () => readConsent() === GRANTED;

/** Puts the visitor back to "not asked", so the banner returns. */
export const clearConsent = () => {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* as above */
  }
  window.dispatchEvent(new CustomEvent('cs-consent', { detail: null }));
};
